'use client';

import { useEffect } from 'react';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider';
import { createDetailPageTitle, setPageTitle } from '@/app/common/utils/pageTitles';
import { useFetchHotelStatic } from './useFetchHotelStatic';
import { useTranslation } from '../../translations/Translation.tsx';

/**
 * Keeps `document.title` in sync with the hotel detail page's own title.
 *
 * The hotel name is only known client-side, so the real title only ever arrives once the static
 * hotel data resolves - the route-level `generateMetadata` can supply the brand placeholder and
 * nothing more. `Hero` mounts this for the pages that render it; a detail route without a Hero has
 * to mount it itself (MPH-1064). `EvoHero` still carries its own copy of the same effect, in line
 * with the rest of the deliberately forked Evo arm.
 */
export function useDetailPageTitle() {
  const { searchInfoData, searchInfoDetailData } = usePageWrapperData();
  const { t } = useTranslation();
  const { data: staticData } = useFetchHotelStatic();

  useEffect(() => {
    if (staticData?.name) {
      const detailPageTitle = createDetailPageTitle({
        hotelName: staticData.name,
        searchInfoData,
        searchInfoDetailData,
        t,
      });

      if (detailPageTitle) {
        setPageTitle(detailPageTitle);
      }
    }
  }, [staticData?.name, searchInfoData, searchInfoDetailData, t]);
}
